import instance, { post } from "../../utils/BaseService";

export async function forgotPasswordSendMail(input: any): Promise<any> {
    return await instance.post('/Authentication/forgotPasswordSendMail', input);
 };
export async function resetPassword(input: any): Promise<any> {
    return await instance.post('/Authentication/resetPassword', input);
 };